var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to2, from2, except, desc) => {
  if (from2 && typeof from2 === "object" || typeof from2 === "function") {
    for (let key of __getOwnPropNames(from2))
      if (!__hasOwnProp.call(to2, key) && key !== except)
        __defProp(to2, key, { get: () => from2[key], enumerable: !(desc = __getOwnPropDesc(from2, key)) || desc.enumerable });
  }
  return to2;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));

// src/index.ts
var src_exports = {};
__export(src_exports, {
  Constr: () => Constr,
  Data: () => Data,
  SLOT_CONFIG_NETWORK: () => SLOT_CONFIG_NETWORK,
  slotToBeginUnixTime: () => slotToBeginUnixTime,
  unixTimeToEnclosingSlot: () => unixTimeToEnclosingSlot
});

// src/data.ts
var data_exports = {};
__export(data_exports, {
  Constr: () => Constr,
  Data: () => Data
});
__reExport(data_exports, typebox_star);
import * as TypeBox from "@sinclair/typebox";
import { fromHex, fromText, toHex } from "@lucid-evolution/core-utils";
import * as CML from "@anastasia-labs/cardano-multiplatform-lib-nodejs";
import * as typebox_star from "@sinclair/typebox";
var Constr = class {
  index;
  fields;
  constructor(index, fields) {
    this.index = index;
    this.fields = fields;
  }
};
var Data = {
  // Types
  // Note: Recursive types are not supported (yet)
  Integer: function(options) {
    const integer = TypeBox.Type.Unsafe({ dataType: "integer" });
    if (options) {
      Object.entries(options).forEach(([key, value]) => {
        integer[key] = value;
      });
    }
    return integer;
  },
  Bytes: function(options) {
    const bytes = TypeBox.Type.Unsafe({ dataType: "bytes" });
    if (options) {
      Object.entries(options).forEach(([key, value]) => {
        bytes[key] = value;
      });
    }
    return bytes;
  },
  Boolean: function() {
    return TypeBox.Type.Unsafe({
      anyOf: [
        {
          title: "False",
          dataType: "constructor",
          index: 0,
          fields: []
        },
        {
          title: "True",
          dataType: "constructor",
          index: 1,
          fields: []
        }
      ]
    });
  },
  Any: function() {
    return TypeBox.Type.Unsafe({ description: "Any Data." });
  },
  Array: function(items, options) {
    const array = TypeBox.Type.Array(items);
    replaceProperties(array, { dataType: "list", items });
    if (options) {
      Object.entries(options).forEach(([key, value]) => {
        array[key] = value;
      });
    }
    return array;
  },
  Map: function(keys, values, options) {
    const map = TypeBox.Type.Unsafe({
      dataType: "map",
      keys,
      values
    });
    if (options) {
      Object.entries(options).forEach(([key, value]) => {
        map[key] = value;
      });
    }
    return map;
  },
  /**
   * Object applies by default a PlutusData Constr with index 0.\
   * Set 'hasConstr' to false to serialize Object as PlutusData List.
   */
  Object: function(properties, options) {
    const object = TypeBox.Type.Object(properties);
    replaceProperties(object, {
      anyOf: [
        {
          dataType: "constructor",
          index: 0,
          // Will be replaced when using Data.Enum
          fields: Object.entries(properties).map(([title, p]) => ({
            ...p,
            title
          }))
        }
      ]
    });
    object.anyOf[0].hasConstr = typeof options?.hasConstr === "undefined" || options.hasConstr;
    return object;
  },
  Enum: function(items) {
    const union = TypeBox.Type.Union(items);
    replaceProperties(union, {
      anyOf: items.map(
        (item, index) => item.anyOf[0].fields.length === 0 ? {
          ...item.anyOf[0],
          index
        } : {
          dataType: "constructor",
          title: (() => {
            const title = item.anyOf[0].fields[0].title;
            if (title.charAt(0) !== title.charAt(0).toUpperCase()) {
              throw new Error(
                `Enum '${title}' needs to start with an uppercase letter.`
              );
            }
            return item.anyOf[0].fields[0].title;
          })(),
          index,
          fields: item.anyOf[0].fields[0].items || item.anyOf[0].fields[0].anyOf[0].fields
        }
      )
    });
    return union;
  },
  /**
   * Tuple is by default a PlutusData List.\
   * Set 'hasConstr' to true to apply a PlutusData Constr with index 0.
   */
  Tuple: function(items, options) {
    const tuple = TypeBox.Type.Tuple(items);
    replaceProperties(tuple, {
      dataType: "list",
      items
    });
    if (options) {
      Object.entries(options).forEach(([key, value]) => {
        tuple[key] = value;
      });
    }
    return tuple;
  },
  Literal: function(title) {
    if (title.charAt(0) !== title.charAt(0).toUpperCase()) {
      throw new Error(
        `Enum '${title}' needs to start with an uppercase letter.`
      );
    }
    const literal = TypeBox.Type.Literal(title);
    replaceProperties(literal, {
      anyOf: [
        {
          dataType: "constructor",
          title,
          index: 0,
          // Will be replaced in Data.Enum
          fields: []
        }
      ]
    });
    return literal;
  },
  Nullable: function(item) {
    return TypeBox.Type.Unsafe({
      anyOf: [
        {
          title: "Some",
          description: "An optional value.",
          dataType: "constructor",
          index: 0,
          fields: [item]
        },
        {
          title: "None",
          description: "Nothing.",
          dataType: "constructor",
          index: 1,
          fields: []
        }
      ]
    });
  },
  /**
   * Convert PlutusData to Cbor encoded data.\
   * Or apply a shape and convert the provided data struct to Cbor encoded data.
   */
  to,
  /** Convert Cbor encoded data to PlutusData */
  from,
  /**
   * Note Constr cannot be used here.\
   * Strings prefixed with '0x' are not UTF-8 encoded.
   */
  fromJson,
  /**
   * Note Constr cannot be used here, also only bytes/integers as Json keys.\
   */
  toJson,
  void: function() {
    return "d87980";
  },
  castFrom,
  castTo
};
function to(data, type, options = {}) {
  const { canonical = false } = options;
  function serialize(data2) {
    try {
      if (typeof data2 === "bigint") {
        return CML.PlutusData.new_integer(
          CML.BigInteger.from_str(data2.toString())
        );
      } else if (typeof data2 === "string") {
        return CML.PlutusData.new_bytes(fromHex(data2));
      } else if (data2 instanceof Constr) {
        const { index, fields } = data2;
        const plutusList = CML.PlutusDataList.new();
        fields.forEach((field) => plutusList.add(serialize(field)));
        return CML.PlutusData.new_constr_plutus_data(
          CML.ConstrPlutusData.new(
            CML.BigInteger.from_str(index.toString()).as_u64(),
            plutusList
          )
        );
      } else if (data2 instanceof Array) {
        const plutusList = CML.PlutusDataList.new();
        data2.forEach((arg) => plutusList.add(serialize(arg)));
        return CML.PlutusData.new_list(plutusList);
      } else if (data2 instanceof Map) {
        const plutusMap = CML.PlutusMap.new();
        for (const [key, value] of data2.entries()) {
          plutusMap.set(serialize(key), serialize(value));
        }
        return CML.PlutusData.new_map(plutusMap);
      }
      throw new Error("Unsupported type");
    } catch (error) {
      throw new Error("Could not serialize the data: " + error);
    }
  }
  const d = type ? castTo(data, type) : data;
  return canonical ? serialize(d).to_canonical_cbor_hex() : serialize(d).to_cardano_node_format().to_cbor_hex();
}
function from(raw, type) {
  function deserialize(data2) {
    if (data2.kind() === 0) {
      const constr = data2.as_constr_plutus_data();
      const l = constr.fields();
      const desL = [];
      for (let i = 0; i < l.len(); i++) {
        desL.push(deserialize(l.get(i)));
      }
      return new Constr(parseInt(constr.alternative().toString()), desL);
    } else if (data2.kind() === 1) {
      const m = data2.as_map();
      const desM = /* @__PURE__ */ new Map();
      const keys = m.keys();
      for (let i = 0; i < keys.len(); i++) {
        desM.set(deserialize(keys.get(i)), deserialize(m.get(keys.get(i))));
      }
      return desM;
    } else if (data2.kind() === 2) {
      const l = data2.as_list();
      const desL = [];
      for (let i = 0; i < l.len(); i++) {
        desL.push(deserialize(l.get(i)));
      }
      return desL;
    } else if (data2.kind() === 3) {
      return BigInt(data2.as_integer().to_str());
    } else if (data2.kind() === 4) {
      return toHex(data2.as_bytes());
    }
    throw new Error("Unsupported type");
  }
  const data = deserialize(CML.PlutusData.from_cbor_hex(raw));
  return type ? castFrom(data, type) : data;
}
function fromJson(json) {
  function toData(json2) {
    if (typeof json2 === "string") {
      return json2.startsWith("0x") ? toHex(fromHex(json2.slice(2))) : fromText(json2);
    }
    if (typeof json2 === "number") return BigInt(json2);
    if (typeof json2 === "bigint") return json2;
    if (json2 instanceof Array) return json2.map((v) => toData(v));
    if (json2 instanceof Object) {
      const tempMap = /* @__PURE__ */ new Map();
      Object.entries(json2).forEach(([key, value]) => {
        tempMap.set(toData(key), toData(value));
      });
      return tempMap;
    }
    throw new Error("Unsupported type");
  }
  return toData(json);
}
function toJson(plutusData) {
  function fromData(data) {
    if (typeof data === "bigint" || typeof data === "number" || typeof data === "string" && !isNaN(parseInt(data)) && data.slice(-1) === "n") {
      const bigint = typeof data === "string" ? BigInt(data.slice(0, -1)) : data;
      return parseInt(bigint.toString());
    }
    if (typeof data === "string") {
      try {
        return new TextDecoder(void 0, { fatal: true }).decode(
          fromHex(data)
        );
      } catch (_) {
        return "0x" + toHex(fromHex(data));
      }
    }
    if (data instanceof Array) return data.map((v) => fromData(v));
    if (data instanceof Map) {
      const tempJson = {};
      data.forEach((value, key) => {
        const convertedKey = fromData(key);
        if (typeof convertedKey !== "string" && typeof convertedKey !== "number") {
          throw new Error(
            "Unsupported type (Note: Only bytes or integers can be keys of a JSON object)"
          );
        }
        tempJson[convertedKey] = fromData(value);
      });
      return tempJson;
    }
    throw new Error(
      "Unsupported type (Note: Constructor cannot be converted to JSON)"
    );
  }
  return fromData(plutusData);
}
function castFrom(data, type) {
  const shape = type;
  if (!shape) throw new Error("Could not type cast data.");
  const shapeType = (shape.anyOf ? "enum" : "") || shape.dataType;
  switch (shapeType) {
    case "integer": {
      if (typeof data !== "bigint") {
        throw new Error("Could not type cast to integer.");
      }
      integerConstraints(data, shape);
      return data;
    }
    case "bytes": {
      if (typeof data !== "string") {
        throw new Error("Could not type cast to bytes.");
      }
      bytesConstraints(data, shape);
      return data;
    }
    case "constructor": {
      if (isVoid(shape)) {
        if (!(data instanceof Constr) || data.index !== 0 || data.fields.length !== 0) {
          throw new Error("Could not type cast to void.");
        }
        return void 0;
      } else if (data instanceof Constr && data.index === shape.index && (shape.hasConstr || shape.hasConstr === void 0)) {
        const fields = {};
        if (shape.fields.length !== data.fields.length) {
          throw new Error(
            "Could not type cast to object. Fields do not match."
          );
        }
        shape.fields.forEach((field, fieldIndex) => {
          const title = field.title || "wrapper";
          if (/[A-Z]/.test(title[0])) {
            throw new Error(
              "Could not type cast to object. Object properties need to start with a lowercase letter."
            );
          }
          fields[title] = castFrom(data.fields[fieldIndex], field);
        });
        return fields;
      } else if (data instanceof Array && !shape.hasConstr && shape.hasConstr !== void 0) {
        const fields = {};
        if (shape.fields.length !== data.length) {
          throw new Error("Could not ype cast to object. Fields do not match.");
        }
        shape.fields.forEach((field, fieldIndex) => {
          const title = field.title || "wrapper";
          if (/[A-Z]/.test(title[0])) {
            throw new Error(
              "Could not type cast to object. Object properties need to start with a lowercase letter."
            );
          }
          fields[title] = castFrom(data[fieldIndex], field);
        });
        return fields;
      }
      throw new Error("Could not type cast to object.");
    }
    case "enum": {
      if (shape.anyOf.length === 1) {
        return castFrom(data, shape.anyOf[0]);
      }
      if (!(data instanceof Constr)) {
        throw new Error("Could not type cast to enum.");
      }
      const enumShape = shape.anyOf.find(
        (entry) => entry.index === data.index
      );
      if (!enumShape || enumShape.fields.length !== data.fields.length) {
        throw new Error("Could not type cast to enum.");
      }
      if (isBoolean(shape)) {
        if (data.fields.length !== 0) {
          throw new Error("Could not type cast to boolean.");
        }
        switch (data.index) {
          case 0:
            return false;
          case 1:
            return true;
        }
        throw new Error("Could not type cast to boolean.");
      } else if (isNullable(shape)) {
        switch (data.index) {
          case 0: {
            if (data.fields.length !== 1) {
              throw new Error("Could not type cast to nullable object.");
            }
            return castFrom(data.fields[0], shape.anyOf[0].fields[0]);
          }
          case 1: {
            if (data.fields.length !== 0) {
              throw new Error("Could not type cast to nullable object.");
            }
            return null;
          }
        }
        throw new Error("Could not type cast to nullable object.");
      }
      switch (enumShape.dataType) {
        case "constructor": {
          if (enumShape.fields.length === 0) {
            if (/[A-Z]/.test(enumShape.title[0])) {
              return enumShape.title;
            }
            throw new Error("Could not type cast to enum.");
          } else {
            if (!/[A-Z]/.test(enumShape.title)) {
              throw new Error(
                "Could not type cast to enum. Enums need to start with an uppercase letter."
              );
            }
            if (enumShape.fields.length !== data.fields.length) {
              throw new Error("Could not type cast to enum.");
            }
            const args = enumShape.fields[0].title ? Object.fromEntries(
              enumShape.fields.map((field, index) => [
                field.title,
                castFrom(data.fields[index], field)
              ])
            ) : enumShape.fields.map(
              (field, index) => castFrom(data.fields[index], field)
            );
            return {
              [enumShape.title]: args
            };
          }
        }
      }
      throw new Error("Could not type cast to enum.");
    }
    case "list": {
      if (shape.items instanceof Array) {
        if (data instanceof Constr && data.index === 0 && shape.hasConstr) {
          return data.fields.map(
            (field, index) => castFrom(field, shape.items[index])
          );
        } else if (data instanceof Array && !shape.hasConstr) {
          return data.map(
            (field, index) => castFrom(field, shape.items[index])
          );
        }
        throw new Error("Could not type cast to tuple.");
      } else {
        if (!(data instanceof Array)) {
          throw new Error("Could not type cast to array.");
        }
        listConstraints(data, shape);
        return data.map((field) => castFrom(field, shape.items));
      }
    }
    case "map": {
      if (!(data instanceof Map)) {
        throw new Error("Could not type cast to map.");
      }
      mapConstraints(data, shape);
      const map = /* @__PURE__ */ new Map();
      for (const [key, value] of data.entries()) {
        map.set(castFrom(key, shape.keys), castFrom(value, shape.values));
      }
      return map;
    }
    case void 0: {
      return data;
    }
  }
  throw new Error("Could not type cast data.");
}
function castTo(struct, type) {
  const shape = type;
  if (!shape) throw new Error("Could not type cast struct.");
  const shapeType = (shape.anyOf ? "enum" : "") || shape.dataType;
  switch (shapeType) {
    case "integer": {
      if (typeof struct !== "bigint") {
        throw new Error("Could not type cast to integer.");
      }
      integerConstraints(struct, shape);
      return struct;
    }
    case "bytes": {
      if (typeof struct !== "string") {
        throw new Error("Could not type cast to bytes.");
      }
      bytesConstraints(struct, shape);
      return struct;
    }
    case "constructor": {
      if (isVoid(shape)) {
        if (struct !== void 0) {
          throw new Error("Could not type cast to void.");
        }
        return new Constr(0, []);
      } else if (typeof struct !== "object" || struct === null || shape.fields.length !== Object.keys(struct).length) {
        throw new Error("Could not type cast to constructor.");
      }
      const fields = shape.fields.map(
        (field) => castTo(
          struct[field.title || "wrapper"],
          field
        )
      );
      return shape.hasConstr || shape.hasConstr === void 0 ? new Constr(shape.index, fields) : fields;
    }
    case "enum": {
      if (shape.anyOf.length === 1) {
        return castTo(struct, shape.anyOf[0]);
      }
      if (isBoolean(shape)) {
        if (typeof struct !== "boolean") {
          throw new Error("Could not type cast to boolean.");
        }
        return new Constr(struct ? 1 : 0, []);
      } else if (isNullable(shape)) {
        if (struct === null) return new Constr(1, []);
        else {
          const fields = shape.anyOf[0].fields;
          if (fields.length !== 1) {
            throw new Error("Could not type cast to nullable object.");
          }
          return new Constr(0, [castTo(struct, fields[0])]);
        }
      }
      switch (typeof struct) {
        case "string": {
          if (!/[A-Z]/.test(struct[0])) {
            throw new Error(
              "Could not type cast to enum. Enum needs to start with an uppercase letter."
            );
          }
          const enumIndex = shape.anyOf.findIndex(
            (s) => s.dataType === "constructor" && s.fields.length === 0 && s.title === struct
          );
          if (enumIndex === -1) throw new Error("Could not type cast to enum.");
          return new Constr(enumIndex, []);
        }
        case "object": {
          if (struct === null) throw new Error("Could not type cast to enum.");
          const structTitle = Object.keys(struct)[0];
          if (!/[A-Z]/.test(structTitle)) {
            throw new Error(
              "Could not type cast to enum. Enum needs to start with an uppercase letter."
            );
          }
          const enumEntry = shape.anyOf.find(
            (s) => s.dataType === "constructor" && s.title === structTitle
          );
          if (!enumEntry) throw new Error("Could not type cast to enum.");
          const args = struct[structTitle];
          return new Constr(
            enumEntry.index,
            // check if named args
            args instanceof Array ? args.map(
              (item, index) => castTo(item, enumEntry.fields[index])
            ) : enumEntry.fields.map((entry) => {
              const [_, item] = Object.entries(args).find(
                ([title]) => title === entry.title
              );
              return castTo(item, entry);
            })
          );
        }
      }
      throw new Error("Could not type cast to enum.");
    }
    case "list": {
      if (!(struct instanceof Array)) {
        throw new Error("Could not type cast to array/tuple.");
      }
      if (shape.items instanceof Array) {
        const fields = struct.map(
          (item, index) => castTo(item, shape.items[index])
        );
        return shape.hasConstr ? new Constr(0, fields) : fields;
      } else {
        listConstraints(struct, shape);
        return struct.map((item) => castTo(item, shape.items));
      }
    }
    case "map": {
      if (!(struct instanceof Map)) {
        throw new Error("Could not type cast to map.");
      }
      mapConstraints(struct, shape);
      const map = /* @__PURE__ */ new Map();
      for (const [key, value] of struct.entries()) {
        map.set(castTo(key, shape.keys), castTo(value, shape.values));
      }
      return map;
    }
    case void 0: {
      return struct;
    }
  }
  throw new Error("Could not type cast struct.");
}
function integerConstraints(integer, shape) {
  if (shape.minimum && integer < BigInt(shape.minimum)) {
    throw new Error(
      `Integer ${integer} is below the minimum ${shape.minimum}.`
    );
  }
  if (shape.maximum && integer > BigInt(shape.maximum)) {
    throw new Error(
      `Integer ${integer} is above the maxiumum ${shape.maximum}.`
    );
  }
  if (shape.exclusiveMinimum && integer <= BigInt(shape.exclusiveMinimum)) {
    throw new Error(
      `Integer ${integer} is below the exclusive minimum ${shape.exclusiveMinimum}.`
    );
  }
  if (shape.exclusiveMaximum && integer >= BigInt(shape.exclusiveMaximum)) {
    throw new Error(
      `Integer ${integer} is above the exclusive maximum ${shape.exclusiveMaximum}.`
    );
  }
}
function bytesConstraints(bytes, shape) {
  if (shape.enum && !shape.enum.some((keyword) => keyword === bytes))
    throw new Error(`None of the keywords match with '${bytes}'.`);
  if (shape.minLength && bytes.length / 2 < shape.minLength) {
    throw new Error(
      `Bytes need to have a length of at least ${shape.minLength} bytes.`
    );
  }
  if (shape.maxLength && bytes.length / 2 > shape.maxLength) {
    throw new Error(
      `Bytes can have a length of at most ${shape.minLength} bytes.`
    );
  }
}
function listConstraints(list, shape) {
  if (shape.minItems && list.length < shape.minItems) {
    throw new Error(`Array needs to contain at least ${shape.minItems} items.`);
  }
  if (shape.maxItems && list.length > shape.maxItems) {
    throw new Error(`Array can contain at most ${shape.maxItems} items.`);
  }
  if (shape.uniqueItems && new Set(list).size !== list.length) {
    throw new Error("Array constains duplicates.");
  }
}
function mapConstraints(map, shape) {
  if (shape.minItems && map.size < shape.minItems) {
    throw new Error(`Map needs to contain at least ${shape.minItems} items.`);
  }
  if (shape.maxItems && map.size > shape.maxItems) {
    throw new Error(`Map can contain at most ${shape.maxItems} items.`);
  }
}
function isBoolean(shape) {
  return shape.anyOf && shape.anyOf[0]?.title === "False" && shape.anyOf[1]?.title === "True";
}
function isVoid(shape) {
  return shape.index === 0 && shape.fields.length === 0;
}
function isNullable(shape) {
  return shape.anyOf && shape.anyOf[0]?.title === "Some" && shape.anyOf[1]?.title === "None";
}
function replaceProperties(object, properties) {
  Object.keys(object).forEach((key) => {
    delete object[key];
  });
  Object.assign(object, properties);
}

// src/index.ts
__reExport(src_exports, data_exports);

// src/time.ts
var SLOT_CONFIG_NETWORK = {
  Mainnet: { zeroTime: 1596059091e3, zeroSlot: 4492800, slotLength: 1e3 },
  // Starting at Shelley era
  Preview: { zeroTime: 1666656e6, zeroSlot: 0, slotLength: 1e3 },
  // Starting at Shelley era
  Preprod: {
    zeroTime: 16540416e5 + 1728e6,
    zeroSlot: 86400,
    slotLength: 1e3
  },
  // Starting at Shelley era
  /** Customizable slot config (Initialized with 0 values). */
  Custom: { zeroTime: 0, zeroSlot: 0, slotLength: 0 }
};
function slotToBeginUnixTime(slot, slotConfig) {
  const msAfterBegin = (slot - slotConfig.zeroSlot) * slotConfig.slotLength;
  return slotConfig.zeroTime + msAfterBegin;
}
function unixTimeToEnclosingSlot(unixTime, slotConfig) {
  const timePassed = unixTime - slotConfig.zeroTime;
  const slotsPassed = Math.floor(timePassed / slotConfig.slotLength);
  return slotsPassed + slotConfig.zeroSlot;
}
export {
  Constr,
  Data,
  SLOT_CONFIG_NETWORK,
  slotToBeginUnixTime,
  unixTimeToEnclosingSlot
};
